<template>
  <div class="pc_device-info">
    <div class="info device-info">
      <div>
        <div>
          <img style="width: 210px; height: 210px;" :src="apiProductLogo" alt="">
        </div>
        <div class="device-name">{{ apiProductName }}</div>
        <div class="select-div" @click="goChooseModel">{{$t('PCDeviceInfo.index.646ymq6orm00')}}</div>
      </div>
    </div>
    <div class="info title">
      <div>
        <div class="tip">{{$t('PCDeviceInfo.index.646ymq6ot0k0')}}</div>
        <div class="tip-div">{{$t('PCDeviceInfo.index.646ymq6pd100')}}{{$t('PCDeviceInfo.index.646ymq6pekw0')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import productInfoMixin from '@/mixins/productInfo';
export default {
  name: 'PCDeviceInfo',
  mixins: [productInfoMixin],
  mounted(){
    this.fetchProductInfo(this.$route.query.id)
  },
  methods: {
    goChooseModel(){
      this.$router.push({ name: 'Product' });
    }
  }
};
</script>

<style scoped lang="less">
.pc_device-info {
  width: 300px;
  font-size: 16px;
  color: #282828;
  margin-right: 24px;
  .info {
    background-color: #fff;
    border-radius: 8px;
  }
  .device-info {
    // height: 416px;
    text-align: center;
    padding: 40px 45px 0px;
    overflow: hidden;
    .device-name {
      margin: 16px 0 40px 0;
      font-weight: 600;
    }
    .select-div {
      color: #405FFF;
      cursor: pointer;
      margin-bottom: 40px;
    }
  }
  .title {
    margin-top: 20px;
    // height: 200px;
    padding: 30px 24px 50px;
    .tip {
      text-align: center;
      color: #252629;
      font-weight: 500;
      margin-bottom: 16px;
      line-height: 22px;
      font-weight: bold;
    }
    .tip-div {
      color: #8F949D;
    }
  }
}
</style>
